import { Patient } from 'interfaces';
import { PatientManagement } from '..';
import { useAdminPatientManagementData } from './useAdminPatientManagementData';

export const AdminPatientManagement = () => {
  const {
    patients,
    total,
    nextPage,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    pagination,
    setPagination,
  } = useAdminPatientManagementData();

  return (
    <PatientManagement
      patients={patients as Patient[]}
      total={total}
      nextPage={nextPage}
      pagination={pagination}
      setPagination={setPagination}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
